'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesInventoryController', ['$scope', '$timeout', '$state', 'Global', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'ProjectMaterials', 'Trades', 'taskListService', 'contactService', 'Projects', 'tradeCodeService', 'Builders', 'ProjectTasks', 'aceUtils', 'NgTableParams', 'taskService', 'Materials', 'Inventory',
    function ($scope, $timeout, $state, Global, MeanUser, userService, builderService, ngDialog, toaster, $filter, ProjectMaterials, Trades, taskListService, contactService, Projects, tradeCodeService, Builders, ProjectTasks, aceUtils, NgTableParams, taskService, Materials, Inventory) {

        $scope.global = Global;
        $scope.package = {
            name: 'contacts'
        };
        $scope.user = MeanUser.user;
        $scope.invoices = [];
        $scope.contact = {
            company_emails: [],
            inventory_suppliers: []
        };
        $scope.activeTab = ['CompanyInfo'];
        $scope.suppliersList = [];
        $scope.currentTab = 'InvoiceTab';
        $scope.buttonLabel = 'Inventory Setup';
        $scope.newCompanyEmail = '';
        $scope.inventoryContactAddress = '';
        $scope.inventoryContactPerson = '';
        $scope.inventoryContactPhone = '';
        $scope.editEmail = {};
        $scope.selectedName = '';
        $scope.minDateMoment = moment();
        $scope.main_account_id = null;

        $scope.init = function () {
            userService.getMainAccount($scope.user.username).then(function (user) {
                $scope.main_account_id = user._id;
                Trades.query({ 'main_account_id': user._id }, function (trade) {
                    $scope.my_trade = trade[0];
                    $scope.setInitialLodedData(trade[0]);
                    $scope.getInventorySupplier();
                });
            });
        };

        $scope.getInvoiceList = function () {
            Inventory.query({}, function (inventories) {
                $scope.invoices = inventories.map(e => {
                    e['isEditable'] = false;
                    var isNa = e.orderedMaterials.filter(item => item.phase === 'NA');
                    e['isAdjustmentShow'] = isNa.length === e.orderedMaterials.length;
                    return e;
                });
            });
        }

        $scope.getMaterialSavings = function (invoice) {
            var matItem = invoice.orderedMaterials;
            var totalSaving = 0;
            for (const iterator of matItem) {
                totalSaving += iterator.savings;
            }
            return totalSaving;
        }

        $scope.openADJEmpty = (parentIndex) => {
            ngDialog.openConfirm({
                template: 'databases/views/tmpl/adjust-inventory-invoice.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialog-sm',
                closeByDocument: false,
                closeByEscape: false,
            }).then(function (value) {
                if (!isNaN(value)) {
                    var invoiceItem = $scope.invoices[parentIndex];
                    var copyItem = {};
                    var matItem = invoiceItem.material;
                    var benifits = ((0 * value) - (matItem.bulkPrice * value));
                    copyItem.invoice_number = 'ADJ-' + $scope.user.username;
                    copyItem.date_ordered = new Date();
                    copyItem.date_dalivered = new Date();
                    copyItem.task_code = 'NA';
                    copyItem.phase = 'NA';
                    copyItem.quantity = value;
                    copyItem.price_per_order = 0;
                    copyItem.savings = benifits;
                    invoiceItem.orderedMaterials.push(copyItem);
                    invoiceItem.quantityLeft -= value;
                    invoiceItem.$update(function (success) {
                        $scope.invoices[parentIndex] = success;
                        $timeout(function () {
                            $scope.invoices = $scope.invoices.map(e => {
                                e['isEditable'] = false;
                                var isNa = e.orderedMaterials.filter(item => item.phase === 'NA');
                                e['isAdjustmentShow'] = isNa.length === e.orderedMaterials.length;
                                return e;
                            });
                        }, 10)

                    })
                }
            }, function (value) {
                console.log('in the do something section');
            });
        };
        $scope.openADJ = function (parentIndex, childIndex) {
            ngDialog.openConfirm({
                template: 'databases/views/tmpl/adjust-inventory-invoice.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialog-sm',
                closeByDocument: false,
                closeByEscape: false,
            }).then(function (value) {
                if (!isNaN(value)) {
                    var invoiceItem = $scope.invoices[parentIndex];
                    var copyItem = JSON.parse(JSON.stringify(invoiceItem.orderedMaterials[0]));
                    var matItem = invoiceItem.material;
                    var benifits = ((0 * value) - (matItem.bulkPrice * value));
                    // overide invoice no and quantity
                    copyItem.invoice_number = 'ADJ-' + $scope.user.username;
                    copyItem.date_ordered = new Date();
                    copyItem.date_dalivered = new Date();
                    copyItem.task_code = 'NA';
                    copyItem.phase = 'NA';
                    copyItem.quantity = value;
                    copyItem.price_per_order = invoiceItem.material.bulkPrice;
                    copyItem.savings = benifits;
                    invoiceItem.orderedMaterials.push(copyItem);
                    invoiceItem.quantityLeft -= value;
                    invoiceItem.$update(function (success) {
                        $scope.invoices[parentIndex] = success;
                    })
                }

            }, function (value) {
                console.log('in the do something section');
            });
        }

        $scope.$on('resetInvetoryTab', function (event, data) {
            $scope.currentTab = data.selectedTab;
            $scope.buttonLabel = data.buttonLabel;
        });

        $scope.$on('materialInventoryLoadEvent', function (event, data) {

            var query = { type: 'InventoryFilters', supplier: null, startDate: null, endDate: null, showOnlyLeft: false, userId: null };
            (data.searchProp.supplier !== 'All') && (query.supplier = data.searchProp.supplier);
            (data.searchProp.category !== 'All') && (query.category = data.searchProp.category);
            (data.searchProp.userId) && (query.main_account = data.searchProp.userId);
            if (!data.materialDate && data.searchProp.start && data.searchProp.end) {
                query.startDate = data.searchProp.start;
                query.endDate = data.searchProp.end
            }
            if (data.showOnlyLeft) {
                query.showOnlyLeft = true;
            }
            Inventory.query(query, function (inventories) {
                $scope.invoices = inventories.map((e, i) => {
                    e['invoiceNumber'] = e.trade_code + '-' + e.company_code + '-INVE-00000' + (i + 1);
                    e['isEditable'] = false;
                    var isNa = e.orderedMaterials.filter(item => item.phase === 'NA');
                    e['isAdjustmentShow'] = isNa.length === e.orderedMaterials.length;
                    var output = [];
                    e.orderedMaterials = e.orderedMaterials.map((el, index) => {
                        var temp = el.invoice_number.split('-');
                        temp[temp.length - 1] = index + 1;
                        el.invoice_number = temp.join('-');
                        var existing = output.filter(item => item.phase === el.phase && el.phase != 'NA');
                        if (existing.length) {
                            var existingIndex = output.indexOf(existing[0]);
                            output[existingIndex].quantity += el.quantity;
                            output[existingIndex].savings += el.savings;
                        } else {
                            output.push(el);
                        }
                        return el;
                    });
                    e.$update();
                    e.orderedMaterials = output;
                    return e;
                });
            });
        });
        $scope.getInventorySupplier = function () {
            Materials.query({
                'trade_account': $scope.my_trade._id,
                'get_suppliers': true,
                'isInventory': true,
                'userId': $scope.main_account_id
            }, function (materials) {
                $scope.suppliersList = materials;
            });
        }
        $scope.setInitialLodedData = function (trade) {
            (trade.company_emails && Array.isArray(trade.company_emails)) && ($scope.contact.company_emails = trade.company_emails);
            (trade.inventory_suppliers && Array.isArray(trade.inventory_suppliers)) && ($scope.contact.inventory_suppliers = trade.inventory_suppliers);
            trade.inventoryContactAddress && ($scope.inventoryContactAddress = trade.inventoryContactAddress);
            trade.inventoryContactPerson && ($scope.inventoryContactPerson = trade.inventoryContactPerson);
            trade.inventoryContactPhone && ($scope.inventoryContactPhone = trade.inventoryContactPhone);
        }

        $scope.expendIt = function (activeHeader) {
            var indexNo = $scope.activeTab.indexOf(activeHeader);
            indexNo !== -1 ? $scope.activeTab.splice(indexNo, 1) : $scope.activeTab.push(activeHeader);
        }

        $scope.inventorySetup = function () {
            if ($scope.currentTab === 'SetupTab') {
                $scope.currentTab = 'InvoiceTab'
                $scope.buttonLabel = 'Inventory Setup';
            } else {
                $scope.currentTab = 'SetupTab';
                $scope.buttonLabel = 'Inventory Invoices';
            }
        }

        $scope.addCompanyEmail = function (newCompanyEmail) {
            if (aceUtils.isUndefinedOrNull(newCompanyEmail)) return;
            $scope.contact.company_emails.push(newCompanyEmail);

            $scope.my_trade.company_emails = $scope.contact.company_emails;
            $scope.updateInventorySetup();
            this.newCompanyEmail = '';
        };

        $scope.generateInventoryInvoice = function () {
            ngDialog.openConfirm({
                template: 'databases/views/tmpl/create-inventory-invoice.html',
                scope: $scope,
                className: 'ngdialog-theme-default ngdialog-sm',
                closeByDocument: false,
                closeByEscape: false,
            }).then(function (value) {
                console.log('confirm', value)
                $state.go('create-invoice', { 'supplier': encodeURI(value) });
            }, function (value) {
                console.log('in the do something section');
            });
        };

        $scope.addMaterialSupplierEmail = function (supplier, email) {
            if (aceUtils.isUndefinedOrNull(email)) return;
            var matSuppliers = $scope.contact.inventory_suppliers;
            var found = matSuppliers.filter(item => item.name === supplier)
            if (!found.length) {
                matSuppliers.push({ name: supplier, emails: [email] })
            } else {
                var dataIndex = matSuppliers.findIndex(x => x.name === supplier);
                matSuppliers[dataIndex].emails.push(email);
            }
            $scope.contact.inventory_suppliers = matSuppliers;
            $scope.my_trade.inventory_suppliers = $scope.contact.inventory_suppliers;
            $scope.updateInventorySetup();
            this.newEmail = '';
        };

        $scope.getEmails = function (supplier) {
            var data = $scope.contact.inventory_suppliers.filter(item => item.name === supplier);
            return data.length ? data[0].emails : [];
        }

        $scope.updateInventoryDetails = function () {
            $scope.my_trade.inventoryContactAddress = this.inventoryContactAddress;
            $scope.my_trade.inventoryContactPerson = this.inventoryContactPerson;
            $scope.my_trade.inventoryContactPhone = this.inventoryContactPhone;

            $scope.my_trade.$update(function (results) {
                $scope.my_trade = results;
                $scope.setInitialLodedData(results);
                toaster.pop('success', 'Inventory Setup', 'Updated successfully.');
            }, function (error) {
                toaster.pop('error', 'Inventory Setup', error);
            });
        }

        $scope.viewDetails = function (type, supplier, index, text) {
            $scope.editEmail = {
                'editEmailType': type,
                'editEmailObj': supplier,
                'editEmailIndex': index,
                'editEmailText': text
            };
        };

        $scope.updateEditEmail = function () {
            if (aceUtils.isUndefinedOrNull($scope.editEmail.editEmailText) || !aceUtils.isValidEmail($scope.editEmail.editEmailText)) return;
            if ($scope.editEmail.editEmailType === 1) {
                $scope.contact.company_emails[$scope.editEmail.editEmailIndex] = $scope.editEmail.editEmailText;
                $scope.my_trade.company_emails = $scope.contact.company_emails;
            } else {
                var supplierObj = $scope.contact.inventory_suppliers.filter(item => item.name === $scope.editEmail.editEmailObj)
                supplierObj[0].emails[$scope.editEmail.editEmailIndex] = $scope.editEmail.editEmailText;
                var indexNo = $scope.contact.inventory_suppliers.findIndex(item => item.name === supplierObj[0].name);
                if (indexNo !== -1) {
                    $scope.contact.inventory_suppliers[indexNo] = supplierObj[0];
                    $scope.my_trade.inventory_suppliers = $scope.contact.inventory_suppliers;
                }
            }
            this.editEmailText = '';
            $scope.updateInventorySetup();
        };

        $scope.deleteEmail = function () {
            if ($scope.editEmail.editEmailType === 1) {
                $scope.contact.company_emails.splice($scope.editEmail.editEmailIndex, 1);
                $scope.my_trade.company_emails = $scope.contact.company_emails;
            } else {
                var supplierObj = $scope.contact.inventory_suppliers.filter(item => item.name === $scope.editEmail.editEmailObj)
                var emailIndex = supplierObj[0].emails.indexOf($scope.editEmail.editEmailText);
                supplierObj[0].emails.splice(emailIndex, 1)
                var indexNo = $scope.contact.inventory_suppliers.findIndex(item => item.name === supplierObj[0].name);
                if (indexNo !== -1) {
                    $scope.contact.inventory_suppliers[indexNo] = supplierObj[0];
                    $scope.my_trade.inventory_suppliers = $scope.contact.inventory_suppliers;
                }
            }
            $scope.updateInventorySetup();
        };

        $scope.updateInventorySetup = function () {
            $scope.my_trade.$update(function (results) {
                $scope.my_trade = results;
                $scope.setInitialLodedData(results);
            }, function (error) {
                toaster.pop('error', 'Inventory Setup', error);
            });
        }

        $scope.updateDeliverDate = (newValue, oldValue, indexNo) => {
            $scope.invoices[indexNo].isEditable = false;
            $scope.invoices[indexNo].$update();
        }
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases-inventory.js